export { default } from './TableSortLabel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableSortLabel/index.js
// module id = 368
// module chunks = 0